export default class KibanaFilterMetadata {
    key;
    value;
    type;
    negate;
    alias;
    disabled;
    index;
    params;
    name;
    constructor(key, value, type, negate = false, indexPattern, alias = null, disabled = false) {
        this.key = key;
        this.value = value;
        this.type = type;
        this.negate = negate;
        this.alias = alias;
        this.disabled = disabled;
        this.index = indexPattern;
    }
}
//# sourceMappingURL=osd-filter-metadata.js.map